import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import sortOptions from "../Components/UI/Suggestion/sortOptions";
import AdminAuthContext from "../store/adminStore/admin-auth-context";
import remove from "../utils/apiCalls/remove";
import useHttpFetch from "./useHttpFetch";

const useListStateCustom = ({
	initialTableInfos,
	urlMainEntity,
	calType,
	language,
	noMiddleUrl,
	port,
	notEV,
	routeEntity,
	sendRequest,
	preventDelete,
	navigateKey,
	customNavigateHandler,
	customActionHandler,
	isProcessual,
	customSearchStrInUrl,
	customEditNavigateHandler,
}) => {
	const [datas, setDatas] = useState([]);
	const [tableInfos, setTableInfos] = useState([]);
	const [clonedTableInfos, setClonedTableInfos] = useState([]);
	const [totalRecords, setTotalRecords] = useState(0);
	const [enumOptions, setEnumOptions] = useState(null);

	// const { isLoading: datasAreLoading, sendRequest: sendGetDataReq } = useHttpFetch();
	const { isLoading: totalNumberIsLoading, sendRequest: sendTotalNumberReq } = useHttpFetch(
		false,
		"FNM"
	);
	const { isLoading: enumsAreLoading, sendRequest: sendEnumsGetReq } = useHttpFetch(false, "FNM");
	const { isLoading: deletingRecord, sendRequest: sendDeleteReq } = useHttpFetch(false, "FNM");

	const { clientAuthInfo } = useContext(AdminAuthContext);
	const clientAccessibilities = clientAuthInfo.accessibilities;

	const [actionStatus, setActionStatus] = useState("");
	const navigate = useNavigate();

	const sendReqPerChange = async (attributes) => {
		console.log("in sendReqPerChange");
		console.log(attributes);
		const { search, sort, page, dataLimit, shouldFetchTotalNumber, searchTypes } = attributes;

		const searchedPartUrlArray = [];
		for (const property in search) {
			if (Object.prototype.toString.call(search[property]) === "[object Object]") {
				if (
					search[property]?.from?.trim() !== "" &&
					search[property]?.to?.trim() !== "" &&
					search[property]?.from === search[property]?.to
				) {
					const neededTableInfo = initialTableInfos.find((info) => info.uniqueName === property);
					searchedPartUrlArray.push(`${neededTableInfo.field}==${search[property].from}&`);
				} else {
					if (search[property]?.from?.trim() !== "") {
						const neededTableInfo = initialTableInfos.find((info) => info.uniqueName === property);
						searchedPartUrlArray.push(`${neededTableInfo.field}>=${search[property].from}&`);
					}
					if (search[property]?.to?.trim() !== "") {
						const neededTableInfo = initialTableInfos.find((info) => info.uniqueName === property);
						searchedPartUrlArray.push(`${neededTableInfo.field}<=${search[property].to}&`);
					}
				}
			} else if (search[property]?.trim() !== "") {
				const neededTableInfo = initialTableInfos.find((info) => info.uniqueName === property);
				const comparisonOperator =
					searchTypes[property] === "include" ? "=" : searchTypes[property] === "exact" ? "==" : "=";
				searchedPartUrlArray.push(`${neededTableInfo.field}${comparisonOperator}${search[property]}&`);
			}
		}
		const middlePart = `page=${page}&size=${dataLimit}`;
		const sortedPartUrlArray = [];
		for (const property in sort) {
			if (sort[property]?.trim() !== "") {
				const neededTableInfo = initialTableInfos.find((info) => info.uniqueName === property);
				sortedPartUrlArray.push(`${neededTableInfo.field}:${sort[property]},`);
			}
		}
		const searchedPartUrlStr = searchedPartUrlArray?.length > 0 ? searchedPartUrlArray.join("") : "";
		const sortedPartUrlStr =
			sortedPartUrlArray?.length > 0 ? `&sort=${sortedPartUrlArray.join("")}id:desc` : "&sort=id:desc";

		const getDataUrl = `${
			customSearchStrInUrl ? customSearchStrInUrl : "search"
		}/${urlMainEntity}?${searchedPartUrlStr}${middlePart}${sortedPartUrlStr}`;
		// const getTotalRecordUrl = `${
		// 	customSearchStrInUrl ? `${customSearchStrInUrl}/` : ""
		// }totalNumber/${urlMainEntity}?${searchedPartUrlStr}${middlePart}`;
		async function getAll() {
			try {
				const rawDataz = await sendRequest({
					url: getDataUrl,
					calType,
					language,
					noMiddleUrl,
					port,
					notEV,
				});
				const properDatas = rawDataz?.response;
				setDatas(properDatas);
				// if (shouldFetchTotalNumber) {
				//   const rawTotalNumber = await sendTotalNumberReq({ url: getTotalRecordUrl });
				//   setTotalRecords(+rawTotalNumber.response);
				// }
			} catch (err) {
				console.log(err);
				return;
			}
		}
		await getAll();
	};

	useEffect(() => {
		async function getAll(initialSearchUrlPart) {
			const rawDataz = await sendRequest({
				// url: `${
				//   customSearchStrInUrl ? customSearchStrInUrl : "search"
				// }/${urlMainEntity}?fields=${getFieldsUrl}${
				//   initialSearchUrlPart ? initialSearchUrlPart : ""
				// }page=1&size=10`,
				url: `${customSearchStrInUrl ? customSearchStrInUrl : "search"}/${urlMainEntity}?${
					initialSearchUrlPart ? initialSearchUrlPart : ""
				}page=1&size=10&sort=id:desc`,
				calType,
				language,
				noMiddleUrl,
				port,
				notEV,
			});
			if (!rawDataz?.resIsOk) {
				toast.error("بارگذاری اطلاعات با خطا مواجه شد", { toastId: "fetchFailError" });
			} else {
				// const properDatas = isProcessual ? rawDataz?.response : rawDataz?.response?.page;
				const properDatas = rawDataz?.response;
				setDatas(properDatas);
				setTotalRecords(properDatas?.[0]?.totalNumber ? +properDatas?.[0]?.totalNumber : 0);
			}
		}
		async function getEnumOptions(info) {
			const result = await sendEnumsGetReq({
				url: info.enumGetUrl,
				calType,
				language,
				noMiddleUrl,
				port,
				notEV,
			});

			if (!result?.resIsOk) {
				toast.error("بارگذاری اطلاعات با خطا مواجه شد", { toastId: "fetchFailError" });
			} else {
				const properResult = sortOptions(result.response);
				setEnumOptions((ps) => ({ ...ps, [info.uniqueName]: properResult }));
			}
		}

		setTableInfos((ps) => {
			let filteredTableInfos = [...initialTableInfos];
			let newTableInfos = filteredTableInfos.map((each, index) => ({ ...each, order: index + 1 }));
			return newTableInfos;
		});
		setClonedTableInfos((ps) => {
			// let filteredTableInfos = [...initialTableInfos].filter((each) =>
			//   allFieldAccesses.includes(each.uniqueName)
			// );
			// let newTableInfos = filteredTableInfos.map((each, index) => ({ ...each, order: index + 1 }));
			// return newTableInfos;
			// ????? REALLY STRANGE CODE COMMENTED , NEEDS TO BE CONSIDERED AS SOMETHING WHICH MAY CAUSE A BUG ?????
			let filteredTableInfos = [...initialTableInfos];
			let newTableInfos = filteredTableInfos.map((each, index) => ({ ...each, order: index + 1 }));
			return newTableInfos;
		});

		let filteredTableInfos = [...initialTableInfos];
		let newTableInfos = filteredTableInfos.map((each, index) => ({ ...each, order: index + 1 }));
		let enumTableInfos = newTableInfos?.filter(
			(each) => each?.type === "enum"
			// || each?.type === "action"
		);
		if (enumTableInfos.length > 0) {
			for (const each of enumTableInfos) {
				getEnumOptions(each);
			}
		}
		const initialSearchArr = newTableInfos.filter((each) => each?.initialSearchedValue);

		let initialSearchUrlPart = "";
		if (initialSearchArr?.length > 0) {
			for (const each of initialSearchArr) {
				const searchedFieldUrl = `&${each.field}=${each.initialSearchedValue}`;
				initialSearchUrlPart = `${initialSearchUrlPart}${searchedFieldUrl}`;
			}
		}
		getAll(initialSearchUrlPart);
	}, []);

	const actionHandler = async (data, type) => {
		if (customActionHandler) {
			const result = await customActionHandler(data, type);
			return result;
		} else {
			if (type === "edit") {
				if (customEditNavigateHandler) {
					customEditNavigateHandler(data);
				} else {
					let to = `/${routeEntity}/edit/${navigateKey ? data[navigateKey] : `${data.id}`}`;
					navigate(to);
				}
			} else if (type === "add") {
				let to = `/${routeEntity}/add`;
				navigate(to);
			} else if (type === "delete") {
				if (!preventDelete) {
					const wasSuccessfull = await remove({
						actionFetch: sendDeleteReq,
						urlMainEntity,
						paramsId: data.id,
						idInBody: true,
					});
					return wasSuccessfull;
				}
			} else if (type === "view") {
				console.log("do we need a view page ?");
			} else if (type === "navigate") {
				customNavigateHandler(data);
			}
		}
	};

	return {
		datas,
		tableInfos,
		setTableInfos,
		clonedTableInfos,
		totalRecords,
		fieldAccessesAreLoading: false,
		actionStatus,
		setActionStatus,
		actionHandler,
		sendReqPerChange,
		enumOptions,
	};
};

export default useListStateCustom;
